import { handleAPI, API_VERSION_ONE} from "../../itrust_common/utils/apiUtils";



export function scheduleJobLogsLoad(filters){
  const url = `/${API_VERSION_ONE}/schedule_job_logs/`;
  const method = 'GET'

  return {
    type: 'SCHEDULE_JOB_LOGS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function scheduleJobLogCreate(data){
  const url = `/${API_VERSION_ONE}/schedule_job_logs`;
  const method = 'POST'

  return {
    type: 'SCHEDULE_JOB_LOG_CREATE',
    payload: handleAPI(url, {}, method, {...data})
  };
}